import React from 'react';
import { connect } from 'react-redux'
import { setCompletedRun } from '../../store/actions'

//Add 'status' to this list
const ButtonComplete = ({name, disabled, className, onSelectStatus, options, setCompletedRun, completed, status}) => {
  //Delete the line "const { status } = props" entirely. 
  const changeStatus = (options) => {
    onSelectStatus(...options, status)
    setCompletedRun(true)
  }
  return (
    <button
      className={`btn btn--secondary ${className ? className : ''}`}
       onClick={() => changeStatus(options)}
    >
      <span>{name}</span>
    </button>
  );
}

const mapStateToProps = ({ data: { newRun, finalRun, completed } }) => ({
  newRun,
  finalRun,
  completed,
})
const mapDispatchToProps = { setCompletedRun } //removed extra parenthesis here

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonComplete)